
<template>

  <main class="component-main" style="overflow:hidden;">
    <div class="floor-construct">
      <div class="ob-header floor-header">
        <div class="ob-img">
          <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/company.png" />
        </div>
        <div class="ob-header-title">
          <h5 style="border-bottom: 2px solid rgb(0, 153, 191);padding:3px;">{{truncate($store.getters.getActiveBuilding().info.name, 30, 27)}}</h5>
          <h5 class="floor-index">Floor {{floor.info.index}}</h5>
        </div>
      </div>
      <div class="construct-body">
        <div v-for="r in sortByParent(floor.rooms)" :class="`floor-room ${roomStatus(r)}-floor-room`" @click="$store.dispatch('setRoom', {id: r.did, breakpoint: $screen.breakpoint})">
          <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/doorWhite.png" />
          <h6>{{truncate(r.info.hvacName, 11, 7)}}</h6>
        </div>
        <div class="floor-room inactive-floor-room" @click="$store.dispatch('setFloor', {breakpoint: $screen.breakpoint, index: floor.info.index, name: floor.info.name, navNew: true})">
          <h3>+</h3>
          <h6>Add Room</h6>
        </div>
      </div>
    </div>
  </main>

</template>

<script>

import Lang from '@/lib/langTemplates/FloorTemplate';

// import { mapState } from 'vuex';

export default {

  data(){
    return {

    }
  },

  methods: {

    truncate(name, start, end){
      return name.length < start ? name : name.substring(0, end) + '...';
    },

    roomStatus(r){
      if (!r.alerts || !r.meas || r.meas == 'no data' || Object.keys(r.meas).every(i => r.meas[i] === 'no data')) {
        return 'inactive';
      } else if (r.overallAlerts.crit > 0) {
        return 'crit';
      } else if (r.overallAlerts.bad > 0) {
        return 'bad';
      } else {
        return 'good';
      }
    },

    sortByParent(){
      let rooms = this.floor.rooms;
      if (rooms.some(r => r.parent)) {
        const parent = rooms.find(r => typeof r.parent !== 'string');
        rooms = rooms.filter(r => r == parent).concat(rooms.filter(r => r !== parent));
      }
      return rooms;
    }

  },

  computed: {
    floor(){
      return this.$store.getters.getActiveFloor();
    },
    clauses(){
      let lPref = this.$store.state.lang;
      return Object.keys(Lang.clauses).reduce((a, i) => {
        a[i] = Lang.clauses[i][lPref];
        return a;
      }, {});
    }
  },

  watch: {
    '$screen.breakpoint': function(newData, oldData){
      if (newData !== 'sm') this.$router.push({path: `/heatmap/${this.floor.info.index}`});
    }
  },

  mounted(){
    if (Math.round(Date.now()/1000) >= this.$store.state.sessionEnd) {
      this.$store.dispatch('logoutNotif');
      this.$router.push({path: '/'});
    }
    this.$store.dispatch('clearIdsAndIndexes', 'floor');
  }

}

</script>

<style>

.floor-construct {
  height: 100%;
  width: 96%;
  border: 2px solid rgb(0, 153, 191);
  border-radius: 5px;
  overflow-x: hidden;
  overflow-y: scroll;
}

.floor-header {
  min-height: 60px;
  max-heigth: 60px;
}

.ob-header-title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 80%;
}

.ob-header-title h5 {
  margin: 2px;
}

.floor-index {
  width: 50%;
  color: rgb(0, 153, 191);
}

.construct-body {
  width: 98%;
  height: calc(100% - 100px);
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
}

.floor-room {
  width: 73px;
  height: 73px;
  margin: 6px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.floor-room img {
  width: 50%;
  margin-top: 10%;
}

.floor-room h3 {
  margin: 0px;
}

.floor-room h6 {
  margin: 3px;
  text-align: center;
}

.inactive-floor-room {
  background-color: #545457;
}

.crit-floor-room {
  background-color: #a82232;
}

.bad-floor-room {
  background-color: #c7ac4e;
}

.good-floor-room {
  background-color: #66ad5f;
}

</style>



// WEBPACK FOOTER //
// src/components/floor/Floor.vue